import { TableCell } from "@mui/material";
import TimelineIcon from "@mui/icons-material/Timeline";
import SendRequestConfig from "./SendRequestConfig";
import Modal from "../../../Components/Modal/Modal";
import Button from "../../../Components/Button";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { IRolePairPositionTableReport } from "../../../Interfaces/deltaHedgeAccounts";
import { memo, useState } from "react";
import SendDeltaOrderRequestConfig from "../PortfoPairPosition/DeltahedgeOrder";
import { DeltaHedgeOrderType } from "src/Interfaces/deltaHedgeOrder";
import UpdateTarget from "src/Pages/OptionDomain/PairPosition/UpdateTarget";
import { Edit } from "@mui/icons-material";
import { StepOptionOrderType } from "src/Interfaces/stepInterfaces";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">سفارش باز</span>
      </TableCell>
      <TableCell />
      <TableCell />
      <TableCell>
        <span className="!font-black text-black"> کاربر</span>
      </TableCell>
    </>
  );
};

enum ModalMode {
  Chart,
  SendConfig,
  Closed,
  NewModal,
  Edit,
}

const AdditionalCol: React.FC<{
  row: IRolePairPositionTableReport;
  onAction: () => void;
}> = memo(({ row, onAction }) => {
  const [modalMode, setModalMode] = useState(ModalMode.Closed);

  const getModalUI = () => {
    switch (modalMode) {
      // case ModalMode.Chart:
      //   return <ChartUI row={row} />;
      case ModalMode.SendConfig:
        return <SendRequestConfig row={row} onAction={onAction} />;

      case ModalMode.NewModal:
        return (
          <SendDeltaOrderRequestConfig
            row={row}
            processType={DeltaHedgeOrderType.Roll}
            onAction={onAction}
          />
        );

      case ModalMode.Edit:
        return (
          <UpdateTarget
            instrumentNames={[row.instrumentName1!, row.instrumentName2!]}
            initialValues={{
              deltaHedgeOrderType: DeltaHedgeOrderType.Roll,
              newLockProfitTarget: row.openOrder ? Number(row.openOrder) : 0,
              instrumentId1: row.instrumentId1,
              instrumentId2: row.instrumentId2,
              optionOrderType1:
                row.offsetSide === 1
                  ? StepOptionOrderType.Offset
                  : StepOptionOrderType.Open,
              optionOrderType2:
                row.offsetSide === 2
                  ? StepOptionOrderType.Offset
                  : StepOptionOrderType.Open,
              orderSide1: row.orderSide1Enum,
              orderSide2: row.orderSide2Enum,
            }}
            onClose={() => setModalMode(ModalMode.Closed)}
            orderTypeStr="ورود"
            onAction={onAction}
          />
        );

      //         price: parseFloat(row.priceValue?.replaceAll(",", "")),
      // ratio2: row.hedgeFactor?.replaceAll(",", ""),
      // ratio1: "1",
      // instrumentId1: row.instrumentId1,
      // instrumentId2: row.instrumentId2,
      // instrumentName1: row.instrumentName1,
      // instrumentName2: row.instrumentName2,
      // involvedFund: row.involvedFund?.replaceAll(",", ""),
      // contractSize1: row.contractSize1?.replaceAll(",", ""),
      // contractSize2: row.contractSize2?.replaceAll(",", ""),
      // orderSide1: row.orderSide1Enum,
      // orderSide2: row.orderSide2Enum,
      // accountIds: row.users?.map((u) => parseInt(u.userId)),

      default:
        return <></>;
    }
  };

  const editHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setModalMode(ModalMode.Edit);
  };

  return (
    <>
      <TableCell>
        <div className="flex flex-row justify-start items-center gap-2">
          <div>{row.openOrderExpr || "-"}</div>
          {row.openOrderExpr ? (
            <div
              className="hover:bg-slate-300 transition-all rounded p-1 cursor-pointer"
              onClick={editHandler}
            >
              <Edit className="text-sky-700 cursor-pointer" />
            </div>
          ) : (
            <></>
          )}
        </div>
        {modalMode !== ModalMode.Closed ? (
          <Modal
            UI={getModalUI()}
            onClose={() => setModalMode(ModalMode.Closed)}
            fullScreen={modalMode === ModalMode.Chart}
            modalBoxClassName="!pt-[50px]"
          />
        ) : (
          <></>
        )}
      </TableCell>
      <TableCell>
        <Button
          text="ارسال"
          onClick={() => setModalMode(ModalMode.SendConfig)}
          variant="contained"
        />
      </TableCell>
      <TableCell>
        <Button
          text=" ارسال جدید"
          onClick={() => setModalMode(ModalMode.NewModal)}
          variant="contained"
        />
      </TableCell>

      <TableCell className="text-right-td">{row.username}</TableCell>
    </>
  );
});

export const Additional: IAdditional<IRolePairPositionTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
